import { Box, Flex, Image, Link, Paragraph, PlainLink } from '@customerio/pluma-components/react';
import logoMint from '@/assets/images/logos/logo-mint.svg';
import * as styles from './auth-form-layout.css';

type MinimalAppHeaderProps = {
  /**
   * Show the "Don't have an account? Start your free trial." callout — the
   * login index only (Ember's `isLoginIndexRoute`). Signup still lives in
   * Ember, so the link is a plain `/signup` navigation.
   */
  showSignupCallout?: boolean;
};

/**
 * Stripped-down header (logo, plus the signup callout on the login index) shown
 * on the unauthenticated pages. Ported from the Ember `MinimalAppHeader`.
 */
export function MinimalAppHeader({ showSignupCallout = false }: MinimalAppHeaderProps) {
  return (
    <Box
      className={styles.loginHeader}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      backgroundColor="invert-bold"
      px="150"
    >
      <PlainLink href="https://customer.io" data-test-login-signup-logo-link>
        <Image alt="Customer.io" src={logoMint} width="129" height="18" verticalAlign="bottom" />
      </PlainLink>

      {showSignupCallout ? (
        <Flex>
          <Paragraph color="white">
            Don't have an account?{' '}
            <Link
              href="/signup"
              variant="secondary"
              isUnderlined
              className={styles.signupLink}
              data-test-login-signup-link
            >
              Start your free trial
            </Link>
            .
          </Paragraph>
        </Flex>
      ) : null}
    </Box>
  );
}
